module.exports = __webpack_public_path__ + "img/previewer_image.f8137b9c.jpg";